import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { postPAJAE010 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import TicketStatistic from '../../../shared/components/TicketStatistic';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const PAJAE010 = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [option, setOption] = useState('');
    const [dataStatistic, setDataStatistic] = useState({});
    const [countTab, setCountTab] = useState({});
    const [listTicket, setListTicket] = useState({});
    const [point, setPoint] = useState('0');
    const [dataStartDate, setDataStartDate] = useState('');
    const [dataEndDate, setDataEndDate] = useState('');

    const [itemFilter, setItemFilter] = useState([
        { label: '전체', key: 'countTab01', value: '', active: 1 },
        { label: '미사용', key: 'countTab02', value: 'N', active: 0 },
        { label: '사용완료', key: 'countTab03', value: 'Y', active: 0 },
    ]);
    const handleTab = (e) => {
        const dataTab = e.target.dataset.value;

        setItemFilter((prevFilters) =>
            prevFilters.map((item) => ({
                ...item,
                active: item.value === dataTab,
            })),
        );

        if (dataTab !== option) {
            setOption(dataTab);
            setSearchParams(1);
        }
    };

    const handleSearchDateRange = (startDate, endDate) => {
        setDataEndDate(endDate);
        setDataStartDate(startDate);
        getListData(startDate, endDate);
    };
    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAJAE010({
            page,
            options: { ...(option ? { IsUsed: [option] } : {}) },
            startDate: startDateFormat,
            endDate: endDateFormat,
        })
            .then(({ data }) => {
                setDataStatistic(data.data.statistic);
                setCountTab(data.data.countTab);
                setListTicket(data.data.list);
                setPoint(data.data.point);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        handleSearchDateRange(dataStartDate, dataEndDate);
        // eslint-disable-next-line
    }, [page, option]);

    return (
        <div id="content" className="sub-page">
            <div className="container">
                {/* Top Sub Page */}
                <div id="top-sub-page">
                    <SideNav />
                    {/* End Side Nav */}
                    {/* resume */}
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">덴탈잡 이용권 관리</h3>
                            <div className="acs__block">
                                <div className="acs__lf">
                                    <div className="acs__info">
                                        이용권 구매가능
                                        <br />
                                        <span>DV Point</span>
                                    </div>
                                    <div className="acs__point">
                                        <span>{point}</span> P
                                    </div>
                                    <button
                                        type="button"
                                        className="acs__btn"
                                        onClick={() => {
                                            window.open('https://www.dvmall.co.kr/product-list?cat=A30401&page=1&banner=1&best=0', '_blank');
                                        }}
                                    >
                                        DVmall 바로가기
                                    </button>
                                </div>
                                <div className="acs__rt">
                                    <h3 className="acs__tit">미사용 덴탈잡 이용권 보유현황</h3>
                                    <TicketStatistic data={dataStatistic} />
                                </div>
                            </div>
                            <SearchDateRange
                                handleSearchDateRange={handleSearchDateRange}
                                setSearchParams={setSearchParams}
                            />
                            <div className="mtch__block mtch__block--pt10 mtch__block--rp3">
                                {itemFilter.map((item) => (
                                    <Link
                                        to="#"
                                        key={item.key}
                                        className={`mtch__cnd h40 ${item.active ? 'active' : ''}`}
                                        data-value={item.value}
                                        onClick={handleTab}
                                    >
                                        {item.label} ({countTab?.[item.key] || 0})
                                    </Link>
                                ))}
                            </div>
                            {/*  table */}
                            <table className="acs__table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '12%' }}>구매일</th>
                                        <th style={{ width: '28%' }}>상품명</th>
                                        <th style={{ width: '14%' }}>이용권 번호</th>
                                        <th style={{ width: '11%' }}>결제금액</th>
                                        <th style={{ width: '12%' }}>유효기간</th>
                                        <th style={{ width: '10%' }}>사용여부</th>
                                        <th style={{ width: '13%' }}>비고</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTicket && listTicket.length > 0 ? (
                                        listTicket.map((item, index) => {
                                            return (
                                                <tr key={`ticket-${index}`}>
                                                    <td>{formatDate(item?.purchaseDate)}</td>
                                                    <td className="acs__name">{item?.goodName}</td>
                                                    <td>{item?.ticketNum}</td>
                                                    <td>{formatNumberWithCommas(item?.salePrice)}원</td>
                                                    <td>{formatDate(item?.expiryDate)}</td>
                                                    <td>
                                                        {item?.isUsed === 'Y' ? (
                                                            <>
                                                                사용 <br />({formatDate(item?.useDate)})
                                                            </>
                                                        ) : new Date(item?.expiryDate).setHours(0, 0, 0, 0) <
                                                            new Date().setHours(0, 0, 0, 0) ? (
                                                            <span style={{ color: '#f63838' }}>만료</span>
                                                        ) : (
                                                            '미사용'
                                                        )}
                                                    </td>
                                                    <td>{item?.comments ? item?.comments : ''}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={7}>데이터없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                    {/* End resume */}
                </div>
                {/* End Top Sub Page */}
            </div>
        </div>
    );
};

export default PAJAE010;
